export enum DateInterval {
  second = 1e3,
  minute = 6e4,
  hour = 3.6e6,
  day = 8.64e7,
  week = 6.048e8,
  month30 = 2.592e9,
  month31 = 2.6784e9,
  year = 3.1536e10,
  yearLeap = 3.16224e10,
}
